import React, { createContext, useEffect, useState, useMemo } from 'react'
// import DeleteIcon from '@material-ui/icons/Delete';
// import EditIcon from '@material-ui/icons/Edit';
import   { Link } from 'react-router-dom';
import { Button, Container, Grid } from '@material-ui/core';
import AddSharpIcon from '@material-ui/icons/AddSharp';
import { useProductStyles } from '../../styles/js/itemStyles';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import ItemList from './ItemList';
import ItemSearchBar from './ItemSearchBar';
import { MenuValidation } from './MenuValidation';
import { useDispatch, useSelector } from 'react-redux';
import {
    SearchKeyWord,
    SearchItemByName,
    SearchItemByBarcode,
    SearchItemByProsoftRef,
    searchFilterAll,
    searchFilterValid,
    searchFilterNotValid,
    searchFilterNoCover,
    searchFilterNoCategory,
    searchFilterNoBarcode,
    searchFilterNoInternalId,
    SearchItemByCategory,
    loadMore
} from '../../redux/actions/item/ItemAction';
import {
    FILTER_ALL, FILTER_NO_BARCODE,
    FILTER_NO_CATEGORY,
    FILTER_NO_COVER, FILTER_NO_INTERNAL_ID,
    FILTER_NOT_VALID,
    FILTER_VALID
} from '../../redux/ActionType/ActionType'
import ItemBarcode from './ItemBarcode';
import { ItemSearchProsoftRef } from './ItemSearchProsoftRef';
import { useFirestoreConnect } from 'react-redux-firebase';
import { isLoaded } from 'react-redux-firebase';
import { isEmpty } from 'react-redux-firebase';
import ItemSearchCategory from "./ItemSearchCategory";
import useRoles from '../../hooks/useRoles';


const ItemContext = createContext()
export const Items = () => {
    const classes = useProductStyles();
    const [pagination, setPagination] = useState(0);
    const [isInit, setIsinit] = useState(true);
    const [SearchText, setSearchText] = useState("");
    const [SearchBarcode, setSearchBarcode] = useState("");
    const [SearchRef, setSearchRef] = useState("");
    const [keyLoading, setKeyLoading] = useState(false);
    const [findArray, setFindArray] = useState([]);
    const dispatch = useDispatch()


    useFirestoreConnect(() => [
        { collection: 'keyWords', storeAs: 'keyWords' }
    ])


    let getkeyWords = useSelector((state) => state.firestore.ordered.keyWords);

    let keyWords = !isEmpty(getkeyWords) ? getkeyWords[0].keyWords : []

    const searchKeyWord = (e) => {
        let search = e.target.value
        if (search !== '') {
            const find1ArraySimple = []
            for (let i = 0; i < keyWords.length && find1ArraySimple.length < 30; i++) {
                if (keyWords[i].name.toUpperCase().includes(search.toUpperCase())) {
                    find1ArraySimple.push(keyWords[i])
                }
            }

            setFindArray(find1ArraySimple)
            return;
        }
        setFindArray([]);
    }

    useEffect(() => {
        if (!isLoaded(getkeyWords)) {
            setKeyLoading(true);
        } else {
            setKeyLoading(false);
        }
    }, [getkeyWords])


    useEffect(() => {
        if (isInit) {
            dispatch(searchFilterNotValid())
        }
    }, [isInit, dispatch])

    const itemState = useSelector(state => {
        return state.item;
    })
    const { items, isLoading } = itemState
    const { userRole, } = useRoles();

    const handleWipeResult = () => {
        setSearchText('');
        setFindArray([]);
    }

    const onLineSearchKeyWord = (newValue) => {
        dispatch(SearchKeyWord(newValue))
    }

    const HandleSearchItem = () => {
        setIsinit(false);
        dispatch(SearchItemByName(SearchText))
    }

    const HandleSearchItemBarcode = () => {
        setIsinit(false);
        dispatch(SearchItemByBarcode(SearchBarcode))
    }

    const HandleSearchItemProsoftRef = () => {
        setIsinit(false);
        dispatch(SearchItemByProsoftRef(SearchRef))
    }

    const handleSearchByCategory = (category) => {
        category && dispatch(SearchItemByCategory(category))
    }


    const handleFilter = (action) => {

        switch (action) {
            case FILTER_ALL:
                setIsinit(false);
                dispatch(searchFilterAll())
                break;
            case FILTER_VALID:
                setIsinit(false);
                dispatch(searchFilterValid())
                break;
            case FILTER_NOT_VALID:
                setIsinit(false);
                dispatch(searchFilterNotValid())
                break;
            case FILTER_NO_COVER:
                setIsinit(false);
                dispatch(searchFilterNoCover())
                break;
            case FILTER_NO_CATEGORY:
                setIsinit(false);
                dispatch(searchFilterNoCategory())
                break;
            case FILTER_NO_BARCODE:
                setIsinit(false);
                dispatch(searchFilterNoBarcode())
                break;
            case FILTER_NO_INTERNAL_ID:
                setIsinit(false);
                dispatch(searchFilterNoInternalId())
                break;
            default:
                dispatch(searchFilterAll())
                break;
        }
    }

    const handleLoadMore = () => {
        dispatch(loadMore())
    }

    const hasMore = useMemo(() => {
        return (items?.length % 30) === 0
    }, [items])


    return (
        <ItemContext.Provider value={{ pagination, setPagination }}>
            <div style={{ marginBottom: "20px" }}>
                {userRole?.Admin !== true && userRole?.ItemCreator !== true ? ""
                    :

                    <Link  className={classes.linkStyle} to="/new-item">
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<AddSharpIcon />}
                            style={{ backgroundColor: "#2196f3" }}
                        >
                            Nouveau
                        </Button>
                    </Link>

                }

                <Button
                    variant="outlined"
                    style={{ borderColor: "#00a152", color: "#00a152", }}
                    size="small"
                    className={classes.button}
                    startIcon={<DescriptionSharpIcon />}>
                    Exporter vers Excell
                </Button>

                <div style={{ float: "right", marginBottom: "20px" }}>
                    <MenuValidation setValidationStatus={handleFilter} />
                </div>

            </div>

            <Container maxWidth="lg" style={{ marginBottom: "20px" }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <ItemSearchBar SearchText={SearchText} onLineSearchKeyWord={onLineSearchKeyWord}
                                       searchKeyWord={searchKeyWord} keyLoading={keyLoading}
                                       setSearchText={setSearchText}
                                       HandleSearchItem={HandleSearchItem}
                                       handleWipeResult={handleWipeResult}
                                       findArray={findArray} />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                        <ItemBarcode SearchBarcode={SearchBarcode}
                                     searchKeyWord={searchKeyWord} setSearchBarcode={setSearchBarcode}
                                     HandleSearchItemBarcode={HandleSearchItemBarcode}
                                     findArray={findArray} />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                        <ItemSearchProsoftRef SearchRef={SearchRef}
                                              setSearchRef={setSearchRef}
                                              HandleSearchItemProsoftRef={HandleSearchItemProsoftRef}
                                              findArray={findArray} />
                    </Grid>

                    <Grid item xs={8}>
                        <ItemSearchCategory onSearch={handleSearchByCategory} />
                    </Grid>

                    <Grid item xs={4}>
                        <Button variant={'contained'}
                                onClick={handleLoadMore}
                                disabled={isLoading || !hasMore}
                                style={{ paddingTop: 10 }}
                        >
                            LoadMore
                        </Button>
                    </Grid>

                </Grid>
            </Container>
            <ItemList items={items} isLoading={isLoading} />


        </ItemContext.Provider>
    )
}
